/**
 * How It Works - Mobile Carousel
 * Handles snap-scroll carousel with pagination dot indicators.
 * Compatible with the Shopify theme editor.
 */
(function () {
  function initHowItWorks(container) {
    var section = container || document.querySelector('.oddit-section-how-it-works');
    if (!section) return;

    var wrapper = section.querySelector('.oddit-section-how-it-works__steps-wrapper');
    var steps = section.querySelectorAll('.oddit-section-how-it-works__step');
    var dots = section.querySelectorAll('.oddit-section-how-it-works__dot');

    if (!wrapper || steps.length === 0) return;

    function updateActiveDot() {
      if (dots.length === 0) return;
      var wrapperCenter = wrapper.scrollLeft + wrapper.offsetWidth / 2;
      var activeIndex = 0;
      var minDist = Infinity;

      steps.forEach(function (step, i) {
        var stepCenter = step.offsetLeft + step.offsetWidth / 2;
        var dist = Math.abs(wrapperCenter - stepCenter);
        if (dist < minDist) {
          minDist = dist;
          activeIndex = i;
        }
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle(
          'oddit-section-how-it-works__dot--active',
          i === activeIndex
        );
      });
    }

    // Scroll event listener (debounced via scroll-end detection)
    var scrollTimeout;
    function onScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    }
    wrapper.addEventListener('scroll', onScroll, { passive: true });

    // Dot click navigation
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        var step = steps[index];
        if (!step) return;
        var stepCenter = step.offsetLeft + step.offsetWidth / 2;
        wrapper.scrollTo({
          left: stepCenter - wrapper.offsetWidth / 2,
          behavior: 'smooth'
        });
      });
    });

    // Store cleanup reference on the section element
    section.__howItWorksCleanup = function () {
      clearTimeout(scrollTimeout);
      wrapper.removeEventListener('scroll', onScroll);
    };
  }

  // Initial load
  initHowItWorks();

  // Shopify theme editor: re-initialize on section load
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.oddit-section-how-it-works');
    if (section) initHowItWorks(section);
  });

  // Shopify theme editor: clean up on section unload
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.oddit-section-how-it-works');
    if (section && typeof section.__howItWorksCleanup === 'function') {
      section.__howItWorksCleanup();
    }
  });
})();
